// @flow

import {
  UPDATE_CART_GROUPS,
  UPDATE_CART_GROUPS_PRICE,
} from './constants';
import type { State, ReducerActions } from './types';

export default (state: State = {}, action: ReducerActions): State => {
  switch (action.type) {
    case UPDATE_CART_GROUPS: {
      return {
        ...state,
        [action.pdbId]: {
          ...state[action.pdbId] || {},
          groups: action.groups,
        },
      };
    }
    case UPDATE_CART_GROUPS_PRICE: {
      return {
        ...state,
        [action.pdbId]: {
          ...state[action.pdbId] || {},
          groupsPrice: action.price,
        },
      };
    }
    default:
      return state;
  }
};
